import React from 'react';

const SpaceCard = ({ space, active, hideDescription = false }) => {
  return (
    <div className="bg-brand-softer ring-1 ring-amber-200 rounded-3xl p-4 my-4 shadow-sm">
      <div className="flex flex-col h-[200px] w-[164px]">
        {/* Title + size */}
        <h1 className="text-lg font-bold truncate">{space.name}</h1>
        <h2 className="text-gray-500 text-sm">{space.size}m2</h2>

        {/* Fixed description area */}
        <div className="mt-2 h-[50px]">
          {hideDescription ? (
            <div className="h-full" />
          ) : (
            <p className="text-xs leading-4 text-gray-400 line-clamp-3">
              {space.description || '—'}
            </p>
          )}
        </div>

        {/* Spacer */}
        <div className="flex-grow" />

        {/* Price at bottom */}
        <div className="mt-auto self-end text-yellow-500">
          <span className="text-xl font-bold">{space.price}€</span>
          <span className="block text-gray-400 text-xs">+ Taxes</span>
        </div>
      </div>
    </div>
  );
};

export default SpaceCard;
